import { CommonModule, NgClass } from "@angular/common";
import {
	Component,
	EventEmitter,
	Input,
	model,
	OnInit,
	Output,
	signal,
	ViewEncapsulation,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SvgIconComponent } from "angular-svg-icon";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { TextareaModule } from "primeng/textarea";

@Component({
    selector: "app-error-dialog",
    imports: [
        ButtonModule,
        DialogModule,
        FormsModule,
        SvgIconComponent,
        TextareaModule,
        NgClass,
        CommonModule
    ],
    templateUrl: "./error-dialog.component.html",
    styleUrl: "./error-dialog.component.scss",
    encapsulation: ViewEncapsulation.None
})
export class ErrorDialogComponent {
	@Input() dialogId?: string;
	@Input() dialogHeader?: string = "Disable";
	@Input() title?: string;
	@Input() content?: string;
	@Input() cancelBttnText: string = $localize`:@@users.cancel:Cancel`;
	@Input() btnName = "OK";
	@Output() onSuccess = new EventEmitter();
	@Output() onCancel = new EventEmitter();
	@Input() comment?: boolean = false;
	@Input() closable = false;
	@Input() isArchive?: boolean = false;
	@Input() loading: boolean = false;
	public readonly isShowDialog = model<boolean>(false);
	commentText = "";

	// all Dialog control here
	showDialog() {
		this.isShowDialog.set(true);
	}

	closeDialog() {
		this.isShowDialog.set(false);
		this.onCancel.emit();
	}

	hideDialog() {
		this.isShowDialog.set(false);
	}

	confirmDialog() {
		this.onSuccess.emit();
	}
}
